module.exports = __webpack_public_path__ + "img/jj.a79c0be7.png";